import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT, formatters } from 'common';
import DefListColumn from 'components/DefListColumn';
import styles from './styles.css';
import messages from './messages';

const AccountPanel = ({
  isAccountActive,
  correspondentName,
  correspondentDeposit,
  accountOpenedDate,
  apexAccountNumber,
  showAllFields,
  restrictionCodes,
}) => {
  const todayDate = moment().format(ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT);
  const sixtyDaysAgoDate = moment().subtract(60, 'days').format(ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT);

  return (
    <div className={styles.panel}>
      <div className={styles.leftPane}>
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.accountData} />}
          data={apexAccountNumber}
          dataTestHandle="transferPanel__accountData"
        />
        {showAllFields &&
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.active} />}
            data={<FormattedMessage {...messages[isAccountActive ? 'yes' : 'no']} />}
            dataTestHandle="transferPanel__active"
          />}
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.correspondent} />}
          data={formatters.formatCorrespondentName(correspondentName)}
          dataTestHandle="transferPanel__correspondent"
        />
        {/* adding skipSearch prevents the query params from being overwritten when going to accounts */}
        <a className={styles.accountsUILink} href={`/accounts/#/${apexAccountNumber}/activity?startDate=${sixtyDaysAgoDate}&endDate=${todayDate}&skipSearch=true`} target="_blank" >
          <FormattedMessage {...messages.viewAccountActivity} />
        </a>
      </div>
      <div className={styles.rightPane}>
        {showAllFields && (
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.ibDeposits} />}
            data={formatters.formatDollars(correspondentDeposit)}
            dataTestHandle="transferPanel__ibDeposits"
          />
        )}
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.openedDate} />}
          data={accountOpenedDate}
          dataTestHandle="transferPanel__openedDate"
        />
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.restrictions} />}
          data={restrictionCodes || '-'}
          dataTestHandle="transferPanel__openedDate"
        />

      </div>
    </div>
  );
};

AccountPanel.propTypes = {
  isAccountActive: PropTypes.bool.isRequired,
  correspondentName: PropTypes.string.isRequired,
  correspondentDeposit: PropTypes.number.isRequired,
  accountOpenedDate: PropTypes.string.isRequired,
  apexAccountNumber: PropTypes.string.isRequired,
  onEditAccountButtonClicked: PropTypes.func.isRequired,
  allowEditAccount: PropTypes.bool.isRequired,
  showAllFields: PropTypes.bool.isRequired,
  restrictionCodes: PropTypes.string.isRequired,
};

export default AccountPanel;



// WEBPACK FOOTER //
// ./src/components/AccountPanel/index.js